import React, { useState } from 'react';

import { readCMSValue, getDefault, getDefaultUrlPicture } from 'modules/shared-cms/utils';
import { SignImageProps } from '.';

import styles from './sign-image-component.module.css';

export const SignImage: React.FC<SignImageProps> = ({
    name: wrappedName,
    logo: wrappedLogo,
    url: wrappedUrl,
}: SignImageProps) => {
    const [isError, setIsError] = useState(false);

    const unwrappedName = getDefault(readCMSValue(wrappedName), '');
    const unwrappedLogo = getDefaultUrlPicture(wrappedLogo);
    const unwrappedUrl = readCMSValue(wrappedUrl);
    if (!isError && unwrappedLogo) {
        if (unwrappedUrl) {
            return (
                <a href={unwrappedUrl} target="blank">
                    <div className={styles.signImageContainer}>
                        <picture>
                            <img
                                alt={unwrappedName}
                                src={unwrappedLogo}
                                onError={() => {
                                    setIsError(true);
                                }}
                            />
                        </picture>
                    </div>
                </a>
            );
        }
        return (
            <div className={styles.signImageContainer}>
                <picture>
                    <img
                        alt={unwrappedName}
                        src={unwrappedLogo}
                        onError={() => {
                            setIsError(true);
                        }}
                    />
                </picture>
            </div>
        );
    }

    return <React.Fragment />;
};
